exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-078753dd] .el-scrollbar__wrap{overflow-x:hidden}[data-v-078753dd] .el-scrollbar__wrap .el-scrollbar__view{padding:10px;height:100%}.app-main[data-v-078753dd]{height:calc(100% - 44px);width:100%;position:relative;overflow:hidden}.fixed-header+.app-main[data-v-078753dd]{padding-top:64px}.hasTagsView .fixed-header+.app-main[data-v-078753dd]{padding-top:98px}\n", ""]);

// exports
